import type { useIdpMigration } from './use-idp-migration';
import { MigrationEmailAlreadyExistsModal } from '@/components/layout/modals/auth/MigrationEmailAlreadyExistsModal';
import { MigrationNotFoundModal } from '@/components/layout/modals/auth/MigrationNotFoundModal';
import { MigrationProfileModal } from '@/components/layout/modals/auth/MigrationProfileModal';
import { MigrationTermsModal } from '@/components/layout/modals/auth/MigrationTermsModal';
import { MigrationThankYouModal } from '@/components/layout/modals/auth/MigrationThankYouModal';
import { MigrationTransferModal } from '@/components/layout/modals/auth/MigrationTransferModal';

type MigrationModalsProps = Omit<
  ReturnType<typeof useIdpMigration>,
  'startIdpResolve' | 'resetMigrationResolveHandled'
>;

/** AuthProvider 配下で移行フロー（resolveIdpSignIn 結果）に応じて表示する一連のモーダル */
export const MigrationModals = ({
  isMigrationNotFoundModalOpen,
  setIsMigrationNotFoundModalOpen,
  migrationModal,
  setMigrationModal,
  migrationAuthStatus,
  migrationProfilePreview,
  migrationRequiredFields,
  migrationPasswordError,
  idpResolveOrigin,
  handleMigrationSubmit,
  closeMigrationModal,
  handleMigrationThankYouComplete,
  handleCreateAccountFromIdp,
  handleThankYouClose,
}: MigrationModalsProps) => {
  return (
    <>
      <MigrationNotFoundModal
        isOpen={isMigrationNotFoundModalOpen}
        onClose={() => setIsMigrationNotFoundModalOpen(false)}
      />
      {/* 移行フロー: resolveIdpSignIn の結果に応じたモーダル */}
      <MigrationEmailAlreadyExistsModal
        isOpen={migrationModal === 'emailAlreadyRegistered'}
        onClose={closeMigrationModal}
      />
      <MigrationTermsModal
        isOpen={migrationModal === 'terms'}
        onClick={() => setMigrationModal('transfer')}
      />
      <MigrationTransferModal
        isOpen={migrationModal === 'transfer'}
        onClick={handleMigrationSubmit}
        authStatus={migrationAuthStatus}
        profilePreview={migrationProfilePreview}
        variant={idpResolveOrigin === 'idp' ? 'registration' : 'migration'}
        requiredFields={migrationRequiredFields}
        passwordServerError={migrationPasswordError}
      />
      <MigrationThankYouModal
        isOpen={migrationModal === 'thankYou'}
        onClose={handleThankYouClose}
        onPrimaryAction={
          idpResolveOrigin === 'migration' ? handleMigrationThankYouComplete : undefined
        }
      />
      <MigrationProfileModal
        isOpen={migrationModal === 'migration'}
        onSubmit={handleCreateAccountFromIdp}
      />
    </>
  );
};
